export default {"src":"/_next/static/media/7-buzzfeed-logo.02307cb2.svg","height":20,"width":108};